{
  "name": "league-of-managers",
  "private": true,
  "version": "0.1.1",
  "build": "20261104.1",
  "repository": {
    "type": "git",
    "url": "https://github.com/burbia/LOM.git"
  },
  "homepage": "https://github.com/burbia/LOM",
  "type": "module",
  "scripts": {
    "start": "node scripts/angular-with-shields.mjs serve --host 0.0.0.0 --port 3000",
    "dev": "node scripts/angular-with-shields.mjs serve --host 0.0.0.0 --port 3000",
    "start:dev": "node scripts/angular-with-shields.mjs serve --configuration dev --host 0.0.0.0 --port 3000",
    "start:local": "node scripts/angular-with-shields.mjs serve --host 0.0.0.0 --port 3000 --proxy-config proxy.local.conf.json",
    "build": "node scripts/angular-with-shields.mjs build",
    "build:dev": "node scripts/angular-with-shields.mjs build --configuration dev",
    "build:prod": "node scripts/angular-with-shields.mjs build --configuration production",
    "watch": "node scripts/angular-with-shields.mjs build --watch --configuration development",
    "lint": "tsc --noEmit -p tsconfig.app.json",
    "test:pwa": "node --test tests/dependency-lock.test.mjs tests/pwa.test.mjs",
    "test:pwa:browser": "node tests/pwa-browser.cjs",
    "test:pwa:nginx": "node tests/pwa-nginx.cjs"
  },
  "dependencies": {
    "@angular/common": "22.1.6",
    "@angular/compiler": "22.1.6",
    "@angular/core": "22.1.6",
    "@angular/forms": "22.1.6",
    "@angular/platform-browser": "22.1.6",
    "@angular/platform-browser-dynamic": "22.1.6",
    "@angular/router": "22.1.6",
    "@angular/service-worker": "22.1.6",
    "@lucide/angular": "^1.43.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.0"
  },
  "devDependencies": {
    "@angular/build": "22.1.8",
    "@angular/cli": "22.1.8",
    "@angular/compiler-cli": "22.1.6",
    "@tailwindcss/postcss": "^4.1.14",
    "postcss": "^8.5.3",
    "sass": "^1.104.0",
    "tailwindcss": "^4.1.14",
    "typescript": "~6.0.3"
  }
}
